import { useTranslation } from 'react-i18next'

import { StringText } from '@/Atomic/Atoms/StringText'
import { Button } from '@/Atomic/Molecules/Button'

import './LoadMoreButton.scss'

interface LoadMoreButtonProps {
  onClick: () => void
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ onClick }) => {
  const { t } = useTranslation()
  return (
    <div className="o-load-more-button-container">
      <Button
        variant="ghost"
        icon="chevron-down"
        iconSize="sm"
        onClick={onClick}
      >
        <StringText className="load-more-text" value={t('common.loadMore')} />
      </Button>
    </div>
  )
}
